import React from 'react';
import { Body, ExternalLink } from '@grnhse/seedling/lib/birch/typography';
import { CompactRow } from '@grnhse/seedling/lib/birch/layouts/compact_row';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack';
import {
  PrimaryButton,
  DangerButton,
} from '@grnhse/seedling/lib/birch/components/buttons';
import { withLocalePrefix } from '../shared/utils/translation';

const t = withLocalePrefix('authorization.authorization_form');

type Props = {
  accountSettingsUrl: string;
  onCancel: () => void;
  disabled?: boolean;
};

export default function ConsentAction({
  accountSettingsUrl,
  onCancel,
  disabled,
}: Props) {
  return (
    <Stack spacing={3}>
      <Body>
        {t('revoke_access_info')}{' '}
        <ExternalLink href={accountSettingsUrl}>
          {t('account_settings')}
        </ExternalLink>
      </Body>
      <CompactRow>
        <PrimaryButton type={'submit'} disabled={disabled}>
          {t('authorize')}
        </PrimaryButton>
        <DangerButton onClick={onCancel}>{t('cancel')}</DangerButton>
      </CompactRow>
    </Stack>
  );
}
